import { call, put, takeLatest } from "redux-saga/effects";
import {
  createPromoCodeFailure,
  createPromoCodeStart,
  createPromoCodeSuccess,
  getPromoCodesFailure,
  getPromoCodesStart,
  getPromoCodesSuccess,
  getActivePromoCodesStart,
  getActivePromoCodesSuccess,
  getActivePromoCodesFailure,
  updatePromoCodeFailure,
  updatePromoCodeStart,
  updatePromoCodeSuccess,
  updatePromoCodeOptimistic,
  deletePromoCodeStart,
  deletePromoCodeSuccess,
  deletePromoCodeFailure,
  sendUserPromoCodeStart,
  sendUserPromoCodeSuccess,
  sendUserPromoCodeFailure,
} from "../redux-slices/promoCodesSlice";
import { createOrUpdatePromoCode, getAllPromoCodes, getActivePromoCodes, sendUserPromoCode, deletePromoCode } from "../../utils/apiCalls";
import { toast } from "../../components/Toast";

export default function* promoCodesWatcher() {
  yield takeLatest(getPromoCodesStart.type, getPromoCodesWorker);
  yield takeLatest(getActivePromoCodesStart.type, getActivePromoCodesWorker);
  yield takeLatest(sendUserPromoCodeStart.type, sendUserPromoCodeWorker);
  yield takeLatest(createPromoCodeStart.type, createPromoCodeWorker);
  yield takeLatest(updatePromoCodeStart.type, updatePromoCodeWorker);
  yield takeLatest(deletePromoCodeStart.type, deletePromoCodeWorker);
}

function* getPromoCodesWorker(action) {
  try {
    const { limit, pageNo } = action && action.payload
    const response = yield getAllPromoCodes({ limit, pageNo });

    yield put(getPromoCodesSuccess(response?.data?.data));
  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(
      getPromoCodesFailure(
        error?.response?.data?.errors[0]?.description
      )
    );
  }
}

function* getActivePromoCodesWorker() {
  try {
    const response = yield getActivePromoCodes();
    yield put(getActivePromoCodesSuccess(response?.data?.data?.data || []));
  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(getActivePromoCodesFailure());
  }
}

function* createPromoCodeWorker(action) {
  try {
    const { data, onSuccess } = action && action.payload;

    yield createOrUpdatePromoCode(data);

    yield put(createPromoCodeSuccess());

    yield toast("Promo code created successfully", "success");

    if (onSuccess && typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(createPromoCodeFailure(error?.response?.data?.errors[0]?.description))
  }
}

function* updatePromoCodeWorker(action) {
  try {
    const { data, onSuccess, optimisticUpdate } = action && action.payload;

    if (optimisticUpdate) {
      yield put(updatePromoCodeOptimistic({
        promocodesId: data.promocodesId,
        newStatus: data.status
      }));
    }

    const response = yield createOrUpdatePromoCode(data);

    yield put(updatePromoCodeSuccess(response?.data?.data));

    if (!optimisticUpdate) {
      yield toast("Promo code updated successfully", "success");
    }

    if (onSuccess && typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
    yield put(updatePromoCodeSuccess(response?.data?.data));

  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");

    const { data, previousStatus } = action.payload;
    yield put(updatePromoCodeFailure({
      error: error?.response?.data?.errors[0]?.description,
      promocodesId: data.promocodesId,
      previousStatus
    }));
  }
}

function* deletePromoCodeWorker(action) {
  try {
    const { promocodesId, onSuccess } = action && action.payload;
    const response = yield deletePromoCode({ promocodesId: promocodesId });
    if (response?.status === 200) {
      yield put(deletePromoCodeSuccess());

      yield toast("Promo code deleted successfully", "success");
      if (onSuccess && typeof onSuccess === 'function') {
        yield call(onSuccess);
      }
    }
    else {
      yield toast(response?.data?.errors[0]?.description || "Failed to delete the Promo code", "error");
      yield put(deletePromoCodeFailure(response?.data?.errors[0]?.description));
    }


  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(deletePromoCodeFailure(error?.response?.data?.errors[0]?.description));
  }
}

function* sendUserPromoCodeWorker(action) {
  try {
    const { userId, promoCode, onSuccess } = action.payload;
    yield sendUserPromoCode({ userId, promoCode });
    yield put(sendUserPromoCodeSuccess());
    yield toast("Promo code sent successfully", "success");
    if (onSuccess) yield call(onSuccess);
  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description || "Failed to send promo code", "error");
    yield put(sendUserPromoCodeFailure());
  }
}
